import $ from 'jquery';
import Reflux  from 'reflux';
import TrackingActions from './actions';
import { defaults, camelCase,  keys, assign, get } from 'lodash';
import Utils from 'medscape/utils';
import cp from './cp';
//import sa from './sa';

class TrackingStore extends Reflux.Store
{
    constructor()
    {
        super();
        this.listenables = TrackingActions;
        this.s_md = {};
        this.s_md.contextData = $.extend({},get(window, 's_md.contextData', {}),true);
        this.s_md.linkTrackVars = get(window, 's_md.linkTrackVars', '');
        this.isFirstPageView = true;

    }
    initRealTimeSpent(timer=5){
        let intervalTime = timer*1000;
        const stopTimer = 30*60*1000; // 30 minutes
        const trackCode = `pvtime_${timer}`;
        let rtsInterval = setInterval(()=>{
          window.wmdPageLink(trackCode);
        },intervalTime);
        setTimeout(()=>{
          clearInterval(rtsInterval);
        },stopTimer);
    }
    trackVP(urlStr=""){
      if(urlStr.length==0){
          return;
      }
      let getData={
        desturl: urlStr
      }
      $.ajax({
          type: 'get',
          url: '/public/vptrack.wxml',
          data: getData,
          cached: false,
          xhrFields: {
              withCredentials: true
          }
      });

    }

    onInit(config){
      this.config = config;
      cp.init(config.CP);
      let ippConfig = $.extend({},config);
      //sa.init(config)
      this.initRealTimeSpent(config["RTS-timer"]);
    }

    onTrackLink(linkEl){
      //if(window.medscape.config.env=='localhost') return;
      const $linkEl = $(linkEl);
      if(window.wmdPageLink==null || $linkEl.hasClass('js-tracking')){
        return;
      }
      let linkTarget = linkEl.getAttribute('target');
      let linkHref = linkEl.getAttribute('href');
      let linkLocation = Utils.getLocation(linkHref);

      if(linkHref!=null){
        if(linkHref.indexOf(".isarticle")<0 && linkHref.indexOf(".medscape.")<0){
          if(linkHref.startsWith('http') || linkHref.startsWith('www')){
            if(linkEl.dataset.module === 'RouterLink') return;
            let linkType = 'exturl';
            // PPE-210888: Duplicate Omniture external link calls
            /* 
            if(window.medscape.user.isLoggedIn){
              linkEl.setAttribute('href',`/px/trk.svr/${medscape.user.sfNumber}?${linkType}=${linkHref}`);
            } else {
                linkEl.setAttribute('href',`/px/tracker/${medscape.user.sfNumber}?${linkType}=${linkHref}`);
            }
            */
            linkEl.addEventListener("click", e => {
              TrackingActions.pageLink("exturl",linkEl);

            })
            if(linkTarget==null || linkTarget.length==0){
              $(linkEl).attr('target','_blank');
            }
          }
        }
        /*$linkEl.off('click.js-tracking').on('click.js-tracking', function(e){
          let el = e.currentTarget;
          const trackData = $(el).data('wmdpagelink') ? $(el).data('wmdpagelink') : 'exturl';
          TrackingActions.pageLink(trackData,el);
        });*/
      }
      else{
          /*$linkEl.off('click.js-tracking').on('click.js-tracking', function(e){
            let el = e.currentTarget;
            let $el = $(el);
            const trackData = $el.data('wmdpagelink') ? $el.data('wmdpagelink') : 'inturl';
            TrackingActions.pageLink(trackData,el);
          });*/
      }
      $linkEl.addClass('js-tracking');
    }

    onTrackContainerLinks(container){
      if(!container) return;
      let $container = $(container);
      $container.find('a[href]:not(.js-tracking)').each((index,el)=>{
          TrackingActions.trackLink(el);
      });

    }

    onPageLink(trackCode="",linkEl) {
      //console.log("onPageLink:\n",linkEl);
      //console.log("trackCode: ",trackCode);
      if(trackCode.length==0){
        return;
      }
      window.wmdPageLink(trackCode,linkEl);
      this.trackVP(`${document.location.href}_${trackCode}`);

    }
    onPageView(pageName = document.location.href){
      if(!this.isFirstPageView){
        window.s_pagename = pageName;
        window._URL = document.location.href;
        //window.s_md.pageName = (document.location.host.replace('www.', '') + document.location.pathname);
        //window.s_md.eVar1 = (document.location.host.replace('www.', '') + document.location.pathname);
        window.s_md.pageURL = document.location.href;
        window.s_md.prop7 = document.location.pathname.substring(1);
        window.s_md.contextData = $.extend({},this.s_md.contextData,true);
        window.s_md.linkTrackVars = this.s_md.linkTrackVars;
        window.wmdPageview(pageName);
      }
      this.trackVP(`${document.location.href}_${document.location.href}`);
      this.isFirstPageView=false;


    }
    onTrack(trackCode=""){
      this.onPageLink(trackCode);

    }

}

export default new TrackingStore();



// WEBPACK FOOTER //
// ./medscape_modules/tracking/store.js